import type { DocumentItem } from "@/types/ui-models";

/** Compara status/tipos vindos do banco (codigos ou rotulos) sem depender de caixa ou acento. */
export function norm(value: string | null | undefined): string {
  return (value ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/_/g, " ")
    .toLowerCase()
    .trim();
}

export function hasStatus(doc: DocumentItem, ...statuses: string[]): boolean {
  const s = norm(doc.status);
  return statuses.some((x) => norm(x) === s);
}

/** Dias ate o vencimento (negativo = vencido). Nulo quando nao ha data de validade valida. */
export function daysToExpiry(doc: DocumentItem, today = new Date()): number | null {
  if (!doc.expiryDate) return null;
  const exp = new Date(`${doc.expiryDate.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(exp.getTime())) return null;
  const base = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.round((exp.getTime() - base.getTime()) / 86_400_000);
}

export function isExpired(doc: DocumentItem): boolean {
  const d = daysToExpiry(doc);
  return hasStatus(doc, "vencido", "vencida") || (d !== null && d < 0);
}

export function uniqueSorted(values: (string | null | undefined)[]): string[] {
  return Array.from(new Set(values.filter((v): v is string => !!v && v.trim() !== ""))).sort((a, b) =>
    a.localeCompare(b, "pt-BR"),
  );
}

/** Formata data ISO para pt-BR; texto vazio vira "—". */
export function fmtDate(value: string | null | undefined): string {
  if (!value) return "—";
  const d = new Date(value.length <= 10 ? `${value}T00:00:00` : value);
  return Number.isNaN(d.getTime()) ? value : d.toLocaleDateString("pt-BR");
}

export function dash(value: string | null | undefined): string {
  return value && value.trim() !== "" ? value : "—";
}
